import React from "react"
import { styled } from "../../stitches.config"

import Link from "../Link"
import TrackingCodeParser from "../../helpers/TrackingCodeParser"
import { useStores } from "../../helpers/useStores"

import logo from "../../assets/img/natemat/logo_white_orange_dot.svg"

const imgSrc = "http://m.natemat-staging.jadwiga.easysoftware.pl/b3cd5d17f9b7cd539f21b18edf508076,500,350,1,0.jpg"

const Hardcover = ({ article, ...props }) => {
    const { UIStore } = useStores();

    return (<Wrap>
        <TrackingCodeParser trackingCode={article.tracking_code} />
        <Tile>
            <Partner><p>Partner numeru:</p> <span></span></Partner>
            <ImageBanner>
                <div>HARDCOVER</div>
                <img src={imgSrc} />
                <p><span>1#</span> Podróż w czasie</p>
            </ImageBanner>
            <Logo>
                <span>
                    magazyn
                </span>
                <img src={logo} />
            </Logo>
        </Tile>
        <List>
            <div>
                <span>W numerze: </span>
                {UIStore.hardcoverConfig.articles.map((item, i) => (<ListItem>
                    <p><span>{i + 1}.</span> <div>
                        <Link to={item.url}>{item.title}</Link>
                        <p>{item.author}</p>
                    </div>
                    </p>
                </ListItem>))}
            </div>
            <Rectangle />
        </List>
    </Wrap>)
}

const Wrap = styled("div", {
    fontFamily: "$grotesk",
    "&>span": {
        color: "#1e202e",
        fontSize: "12px"
    },
    "@media (min-width: 992px)": {
        display: "flex",
        flexDirection: "row"
    }
});

const Tile = styled("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#161616",
    boxShadow: "0px 0px 6px #f72c3f",
    color: "#fff",
    marginBottom: "30px",
    "@media (min-width: 992px)": {
        marginBottom: "0",
        width: "50%"
    }
});

const ImageBanner = styled("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "10px 35px",
    borderTop: "2px solid",
    borderBottom: "2px solid",
    borderColor: "$hardcoverColor",
    maxWidth: "100%",
    "img": {
        maxWidth: "100%",
        height: "auto",
        boxShadow: "0px 0px 15px #000000",
        borderRadius: "50px"
    },
    "&>div": {
        fontSize: "45px",
        fontWeight: 600,
        margin: "10px"
    },
    "&>p": {
        fontFamily: "'Source Serif Pro', serif",
        fontWeight: 600,
        fontSize: "29px",
        margin: "18px",
        "&>span": {
            color: "$hardcoverColor"
        }
    }
});

const Partner = styled("div", {
    width: "100%",
    padding: "18px 35px",
    fontFamily: "$grotesk",
    display: "flex",
    "p": {
        margin: "0"
    },
    "span": {
        marginLeft: "auto",
        display: "inline-block"
    },
    "@media (min-width: 992px)": {
        marginTop: "48px",
        padding: "12px 41px"
    }
});

const List = styled("div", {
    "&>div:first-of-type": {
        paddingBottom: "50px"
    },
    position: "relative",
    "@media (min-width: 992px)": {
        width: "50%",
        "&>div:first-of-type": {
            padding: "65px 50px 100px 32px",
            "&>span": {
                display: "inline-block",
                width: "100%",
                borderBottom: "2px solid",
                bordercolor: "$hardcoverColor"
            }
        }
    }
});

const Logo = styled("div", {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    height: "13px",
    margin: "13px",
    "span": {
        color: "white",
        display: "block",
        height: "14px",
        fontSize: "9px"
    },
    "img": {
        width: "60px"
    },
    "@media (min-width: 992px)": {
        height: "32px",
        "span": {
            fontSize: "11px",
            height: "22px"
        },
        "img": {
            width: "120px"
        }
    }
});

const ListItem = styled("div", {
    marginTop: "2px",
    borderTop: "2px solid",
    borderColor: "$hardcoverColor",
    padding: "22px 0 13px",
    color: "$hardcoverColor",
    "p": {
        margin: "0",
        display: "flex",
        flexDirection: "row",
        alignItems: "baseline",
        "span": {
            display: "block",
            fontSize: "21px",
            paddingRight: "20px"
        },
        "a": {
            display: "block",
            fontSize: "21px",
            color: "#1e202e",
            fontFamily: "'Source Serif Pro', serif",
            transition: "color 150ms ease-out",
            "&:hover": {
                color: "$hardcoverColor",
                transition: "color 150ms ease-in",
                textDecoration: "none"
            }
        },
        "p": {
            fontSize: "13px"
        }
    },
    "@media (min-width: 992px)": {
        marginLeft: "35px",
        "&:first-of-type": {
            border: "none"
        }
    }
});

const Rectangle = styled("div", {
    position: "absolute",
    right: "0",
    bottom: "0",
    width: "0",
    height: "0",
    marginLeft: "auto",
    borderLeft: "26px solid",
    borderTop: "26px solid",
    borderColor: "$hardcoverColor",
    borderRight: "26px solid #000",
    borderBottom: "26px solid #000",
    "@media (min-width: 992px)": {
        borderWidth: "50px"
    }
});

export default Hardcover